import React from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';



const WhyUs = () => {
  return (
    <>
      {/* Why Partner With Us Section */}
      <section className="upcoming-partner-section py-4">
        <Container>
          <Row>
            
            <Col lg={6} className="mb-4 mb-lg-0">
              <p className="upcoming-partner-section-subtitle text-uppercase fw-bold">
                Why Partner With Us? What's In It For You?
              </p>
              <h2 className="upcoming-partner-section-title">
                Your NETWORK is <br /> Your NET WORTH!
              </h2>
              <p>
                At ApexCXOs, we understand that <strong>CISOs, CIOs, CTOs, and CDOs</strong> are on the lookout for real partners
                and we're all about creating partnerships that matter, not just transactions.
              </p>
              <p>
                A thumbs-up from our ApexCXOs community is worth more than any sales pitch.
                If your product genuinely helps tackle their security issues, you'll hear the buzz in our groups.{' '}
                <strong>And that's GOLDEN!</strong>
              </p>
              <p>
                So, if you've got a solution that cuts through the noise and really addresses cybersecurity challenges,
                we're inviting you to join us. Let's make a real difference together, backed by a community
                that trusts each other's word.
              </p>
            </Col>

            <Col lg={6} className="text-center">
              <div className="video-wrapper h-100">
                {/* <iframe 
                  width="100%" 
                  height="100%" 
                  src="https://www.youtube.com/embed/YOUR_VIDEO_ID" 
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen>
                </iframe> */}
                <iframe 
                  width="100%" 
                  height="100%" 
                  src="https://www.youtube.com/embed/mOAW4Nwdlpg"
                  title="EliteCISOs Global - The Middle East Connect 2023 - Keynote Speech by H.E. Dr. Mohamed Al Kuwaiti"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin" 
                  allowFullScreen>
                </iframe>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

      {/* Expect Section */}
      <section className="expect-section py-3 py-lg-5">
        <Container>
          <Row className="justify-content-center g-0 g-lg-5">
            {/* <Col lg={12}>
              <h2 className="mb-3 fw-bold">What can you expect from the event?</h2>
              <p className="mb-4">
                Network with leaders, explore future trends, and gain actionable insights from global experts.
                A day packed with innovation, discussions, and collaborations.
              </p>
              <a href="#" className="btn btn-dark px-4 py-2 rounded-pill">Join Our Partner Program</a>
            </Col> */}
            
            <Col lg={6}>
              <ul className="list-unstyled features-list partner-type">
                <li>
                  <span><i className="fa-solid fa-network-wired"></i></span>
                  <div>Speed Networking</div>
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                <li>
                  <span><i className="fa-solid fa-dumbbell"></i></span>
                  Fitness/Sports Events
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                {/* <li>
                  <span><i className="fi fi-rr-volleyball"></i></span> Sports Events
                  <div>
                    <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a>
                  </div>
                </li> */}
                <li>
                  <span><i className="fa-regular fa-handshake"></i></span> Offsite
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                <li>
                  <span><i className="fa-solid fa-users"></i></span> Roundtables
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
              </ul>
            </Col>
            
            <Col lg={6}>
              <ul className="list-unstyled features-list partner-type">
                <li>
                  <span><i className="fa-solid fa-video"></i></span> Webinar
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                <li>
                  <span><i className="fa-solid fa-desktop"></i></span> Conference
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                <li>
                  <span><i className="fa-solid fa-podcast"></i></span> Podcasts
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
                <li>
                  <span><i className="fa-solid fa-chalkboard-user"></i></span> Academic Workshops
                  <div>
                    {/* <a href="partner-with-us.html#partner" className="btn btn-custom-black">Partner With Us</a> */}
                  </div>
                </li>
              </ul>
            </Col>
            
            <Col lg={12}>
              <div className="text-center">
                <a href="/partner-with-us" className="btn btn-custom-black">
                  Partner With Us
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default WhyUs;
